import Promise from 'promise-polyfill';

window.Promise = window.Promise || Promise;



// WEBPACK FOOTER //
// ./client/utils/promise-polyfill.js